import {
  chakraUseDisclosure,
  ChakraBox,
  ChakraMenu,
  ChakraMenuButton,
  ChakraMenuList,
} from "@airhelp/react-ui-components";
import type { MenuExtendedProps } from "config/menus/menus.d";
import { menuButtonStyles } from "./MenuLinkWithSubmenu.styles";
import { SubmenuContent } from "./SubmenuContent";

export const MenuLinkWithSubmenuDesktop = ({
  menulink,
  submenu,
}: {
  submenu: MenuExtendedProps["subMenu"];
  menulink: JSX.Element;
}) => {
  const { isOpen, onOpen, onClose } = chakraUseDisclosure();

  return (
    <ChakraMenu isOpen={isOpen}>
      <ChakraMenuButton sx={menuButtonStyles} onMouseEnter={onOpen} onMouseLeave={onClose}>
        {menulink}
      </ChakraMenuButton>
      <ChakraMenuList
        onMouseEnter={onOpen}
        onMouseLeave={onClose}
        border="none"
        boxShadow="none"
        rounded="md"
        borderTopLeftRadius="none"
        textAlign="left"
        pt={4}
        pb={0}
        mt={-2}
      >
        <ChakraBox rounded="md" mt={2} boxShadow="md" zIndex="2" data-testid="kyr-menu" onClick={onClose}>
          <SubmenuContent
            submenu={submenu}
            color="greyscale.600"
            _hover={{ color: "primary.900", bg: "greyscale.300" }}
            px={4}
            py={2.5}
            mb={0}
            rounded="md"
          />
        </ChakraBox>
      </ChakraMenuList>
    </ChakraMenu>
  );
};
